"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergeStylesRootStylesheets = void 0;
var React = require("react");
var MergeStylesDefaultContext_1 = require("../contexts/MergeStylesDefaultContext");
/**
 * Get the map of stylesheets available in the context.
 */
var useMergeStylesRootStylesheets = function () {
    return React.useContext(MergeStylesDefaultContext_1.MergeStylesDefaultContext).stylesheets;
};
exports.useMergeStylesRootStylesheets = useMergeStylesRootStylesheets;
//# sourceMappingURL=useMergeStylesRootStylesheets.js.map